export default __webpack_public_path__ + "static/media/Inter-Bold.225dac4c.woff";